import { request } from '@/shared/api/request'

export const edit = (payload) => {
	return request({ url: 'colcontract/industryAgreement/edit', method: 'POST', data: payload })
}
